<template>
  <div class="header">
    <h1>{{ t('connection.discover.title') }}</h1>
    <LanguageSwitch />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import LanguageSwitch from '@/components/controls/LanguageSwitch.vue'

const { t } = useI18n()
</script>

<style lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem 24px;

  h1 {
    margin: 0;
  }
}
</style>
